/* COMPONENTE CARROSSEL RECEITAS */
const slider = document.querySelector('.list-recipes');
const btnLeft = document.querySelector('.scroll-left');
const btnRight = document.querySelector('.scroll-right');
const scrollAmount = 300; // Distância para cada clique

// Variáveis de controle para arrastar
let isDown = false;
let startX;
let scrollLeft;

// Eventos de scroll para os botões
btnLeft.addEventListener('click', () => {
  slider.scrollLeft -= scrollAmount;
});

btnRight.addEventListener('click', () => {
  slider.scrollLeft += scrollAmount;
});

// Eventos de arrastar com o mouse
slider.addEventListener('mousedown', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});

slider.addEventListener('mouseleave', () => {
  isDown = false;
  slider.classList.remove('active');
});

slider.addEventListener('mouseup', () => {
  isDown = false;
  slider.classList.remove('active');
});

slider.addEventListener('mousemove', (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 2; // Velocidade de arrasto
  slider.scrollLeft = scrollLeft - walk;
});

// Para dispositivos móveis
slider.addEventListener('touchstart', (e) => {
  isDown = true;
  startX = e.touches[0].pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});

slider.addEventListener('touchmove', (e) => {
  if (!isDown) return;
  const x = e.touches[0].pageX - slider.offsetLeft;
  const walk = (x - startX) * 2;
  slider.scrollLeft = scrollLeft - walk;
});

slider.addEventListener('touchend', () => {
  isDown = false;
  slider.classList.remove('active');
});

slider.addEventListener('touchcancel', () => {
  isDown = false;
  slider.classList.remove('active');
});


/* END COMPONENTE CARROSSEL RECEITAS */









/* DIALOG INTEGRADO */

const dialog_integrado = document.getElementById("integrado-dialog");
const dialog_integrado_data = document.getElementById("integrado-data");
const dialog_integrado_close = document.getElementById("integrado-close");
dialog_integrado_close.addEventListener('click', function (e) {
  dialog_integrado.close();
});

/* END DIALOG INTEGRADO */





/* DIALOG ERROR */

const dialog_error = document.getElementById("error-dialog");
const dialog_error_data = document.getElementById("error-data");
const dialog_error_close = document.getElementById("error-close");
dialog_error_close.addEventListener('click', function (e) {
  dialog_error.close();
});

/* END DIALOG ERROR */





/* BOX FORMULARIO */

const url_service_map = '/api/v1/origem/tracking/map/?turno={lote}&industria={industria}&producao={producao}';
const url_service_lot = '/api/v1/origem/tracking/?turno={lote}&industria={industria}&producao={producao}';
const url_service_notify = '/api/v1/origem/notify/?id={id}&email={email}&lote={lote}&producao={producao}&industria={industria}&check={check}';




const el_box_integrados = document.querySelector('.box-integrados');



var mapGranjas = L.map('mapGranjas').setView([-23.55052, -46.633308], 5);
L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  maxZoom: 15,
  attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
}).addTo(mapGranjas);


document.getElementById('btn-form-action').addEventListener('click', function (e) {

  e.preventDefault();

  const form_values = getValuesForm();

  const is_valid = validateValuesForm(form_values);


  // EXIBE BOX
  el_box_integrados.classList.add('hidden-box');

  if (is_valid) {
    callServices(); // Faz as requisições
  } else {


    let html_ul = `<ul>`;
    if (!form_values.industria) {
      html_ul += `<li>Selecione seu produto</li>`;
    }
    if (!form_values.lote) {
      html_ul += `<li>Informe o número do lote</li>`;
    }
    if (!form_values.producao) {
      html_ul += `<li>Informe a data de produção</li>`;
    }
    html_ul += `</ul>`;

    dialog_error_data.innerHTML = `
    <div class="content">
      <small>Todos os campos são obrigatórios para buscar a origem do seu produto!</small>
      ${html_ul}
    </div>
    `;

    toggleButtons();

    dialog_error.showModal();

    return false;
  }

});







function showErrorNotify(error) {


  var feedback_error = document.querySelector('#message-error-notify');

  let message = `
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#ff0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> `;

  if (error.message.includes(400)) {
    message += "E-mail é obrigatório!";
  }
  if (error.message.includes(404)) {
    message += "Nenhum registro encontrado!";
  }
  if (error.message.includes(401)) {
    message += "A aplicação precisa ser autenticada!";
  }
  if (error.message.includes(403)) {
    message += "Credenciais inválidas ou usuário não existe!";
  }
  if (error.message.includes(405)) {
    message += "Método de requisição inválido!";
  }
  if (error.message.includes(500)) {
    message += "Erro na aplicação!";
  }

  if (feedback_error) {
    feedback_error.classList.remove('hidden');
    feedback_error.innerHTML = message;
  }
}



function queueNotification() {


  const title_content = document.querySelector('#error-dialog .content .title');
  const form_content = document.querySelector('.email-notify');
  const feedback_content = document.querySelector('.feedback-email-notify');
  var feedback_error = document.querySelector('#message-error-notify');

  const form_values = getValuesForm();
  const email = document.getElementById('field-notify-email').value;
  const newscheck = document.getElementById('field-notify-check').checked;

  const lote = form_values.lote;
  const industria = form_values.industria;
  const producao = form_values.producao;

  if (!email) {
    showErrorNotify({ message: "400" });
    return false;
  }

  const url_notify = url_service_notify
    .replace('{id}', encodeURIComponent(page_id))
    .replace('{email}', encodeURIComponent(email))
    .replace('{industria}', encodeURIComponent(industria))
    .replace('{lote}', encodeURIComponent(lote))
    .replace('{producao}', encodeURIComponent(producao))
    .replace('{check}', encodeURIComponent(newscheck))
    ;

  fetch(url_notify, {
    method: 'GET'
  })
    .then(response => {
      // Verifica se a resposta foi bem-sucedida
      if (response.ok) {
        return response.json(); // Transforma a resposta em JSON
      }
      throw new Error(`Erro: ${response.status}`); // Lança erro se o status não for OK
    })
    .then(data => {

      if (data.success) {
        title_content.classList.add('hidden');
        form_content.classList.add('hidden');
        feedback_content.classList.remove('hidden');
      } else {

        if (feedback_error) {
          feedback_error.classList.remove('hidden');
          feedback_error.innerText = error.message; // Corrige para exibir o erro correto
        }
      }
    })
    .catch(error => {

      showErrorNotify(error);

    });
}






function callServices() {

  toggleButtons();

  const form_values = getValuesForm();

  const url_map = url_service_map
    .replace('{lote}', form_values.lote)
    .replace('{industria}', form_values.industria)
    .replace('{producao}', form_values.producao);

  var mapResponse;
  try {
    // Faz a requisição diretamente com fetch e trata a resposta com .then()
    fetch(url_map)
      .then((mapResponse) => {

        if (mapResponse.status === 200) {
          return mapResponse.json();
        } else {
          // Lida com os erros de status diferentes de 200
          handleError(mapResponse.status);
          return null; // Retorna null se houver erro
        }
      })
      .then((data_map) => {

        if (data_map == null) {
          handleError(404);
          toggleButtons();
        }

        if (data_map != null) {
          genetateTemplates(data_map.data); // Chama a função quando os dados são encontrados
          toggleButtons();
        }

      })
      .catch((error) => {
        // Trata os erros de rede ou outros problemas na requisição
        console.error("Erro na requisição para url_map", error);
        showErrorMessage("Erro ao processar a solicitação.");
      });
  } catch (error) {
    console.group('catch');
    console.error("Erro na função callServices", error);
    console.groupEnd();
  }
}

function handleError(status) {
  let message = "";
  switch (status) {
    case 400:
      message = "Parâmetros de Lote, Indústria e Produção são necessários!";
      break;
    case 404:
      message = `<div class="title">Informações em processamento!</div>`;
      dialog_error.classList.add('form');
      message += `
        <div class="email-notify ">
          <small class="text">Assim que as informações do lote estiverem disponíveis, você será notificado por e-mail.</small>

          <input id="field-notify-email" type="email" name="email" placeholder="Seu e-mail" class="field">

          <label class="check-news" for="field-notify-email">
          <input type="checkbox" id="field-notify-check" name="check" class="check">
          Eu também aceito receber promoções e novidades por email!
          </label>

            <button class="button default" id="btn-form-notify" onclick="queueNotification()">
              Quero ser alertado
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-mail"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
            </button>
            <div id="message-error-notify" class="message-error hidden"></div>
        </div>
        <div class="feedback-email-notify hidden">
          <small class="text">Você receberá um e-mail quando as informações estiverem disponíveis.</small>
        </div>
        `;
      break;
    case 401:
      message = "A aplicação precisa ser autenticada!";
      break;
    case 403:
      message = "Credenciais inválidas ou usuário não existe!";
      break;
    case 405:
      message = "Método de requisição inválido!";
      break;
    case 500:
      message = "Erro na aplicação!";
      break;
    default:
      message = "Erro desconhecido!";
  }

  showErrorMessage(message);
}

function showErrorMessage(message) {
  dialog_error_data.innerHTML = `
    <div class="content">
      ${message}
    </div>
  `;
  toggleButtons();
  dialog_error.showModal();
}






function genetateTemplates(data) {
  makeTemplateIntegrados(data);
}

function makeTemplateIntegrados(data) {


  const el_list_integrados = document.getElementById('list-integrados-items');
  const el_text_qtdintegrados = document.getElementById('text-integrados-qtd');
  el_text_qtdintegrados.innerText = data.length;

  // CRIA MAPA COM PONTOS DE GEO
  if (data.length) {
    data.forEach(function (integrado) {
      var marker = L.marker([integrado.latitude, integrado.longitude]).addTo(mapGranjas);
      marker.on('click', function () {
        showDialogIntegrado(integrado);
      });
    });
    mapGranjas.setZoom(8);
  };


  // CRIA LISTA DE INTEGRADOS
  let html_li = "";
  data.forEach(integrado => {
    html_li += `
    <li>
      <div class="avatar">
        <img
        src="/files/page/origem/produtor_${documentify(integrado.cpf_cnpj)}.jpg"
        alt="Avatar ${capitalize(integrado.nome)}"
        loading="lazy"
        onerror="this.onerror=null;this.src='/files/page/origem/produtor.png';">
      </div>
      <div class="info">
        <div class="name">${capitalize(integrado.nome)}</div>
        <div class="region">${capitalize(integrado.municipio)}</div>
        <div class="details">
          <button class="action-detail-integrado" data-integrado="${btoa(JSON.stringify(integrado))}">Conhaça a Granja</button>
        </div>
      </div>
    </li>`;
  });
  el_list_integrados.innerHTML = html_li;


  // EXIBE BOX
  el_box_integrados.classList.remove('hidden-box');


  // ROLA A PAGINA ATE O BOX INTEGRADOS
  const boxIntegrados = document.querySelector('.box-integrados');

  if (boxIntegrados) {
    boxIntegrados.scrollIntoView({ behavior: 'smooth' });
  }

  // CRIAR ACAO PARA O BOTAO DE CONHECA A GRANJA NO BOX INTEGRADOS
  var elementos = document.getElementsByClassName('action-detail-integrado');

  for (var i = 0; i < elementos.length; i++) {
    elementos[i].addEventListener('click', function (e) {
      e.preventDefault();
      // Recupera o valor do atributo data-integrado
      let data_base64 = e.target.getAttribute('data-integrado');
      const data_integrado = JSON.parse(atob(data_base64));
      // Exibe o valor no console ou use-o como necessário
      showDialogIntegrado(data_integrado);
    });
  }

}

function validateValuesForm(obj) {
  return obj.lote.trim() !== '' && obj.producao.trim() !== '' && obj.industria.trim() !== '';
}

function getValuesForm() {


  // Obtém os valores do formulário
  let lote = document.getElementById('lote').value;


  // Formatar a data para YYYY-MM-DD antes de enviar para a API
  let producao_date = document.getElementById('producao').value;
  let producao = "";
  if (producao_date) {
    let partes = producao_date.split('-'); // no html mostra MES-DIA-ANO
    producao = `${partes[0]}-${partes[1]}-${partes[2]}`;
  }


  // Obtém o valor do radio button selecionado
  let industria = document.querySelector('input[name="industria"]:checked');
  let industria_value = industria ? industria.value : '';


  return {
    lote: lote,
    producao: producao,
    industria: industria_value
  }
}

function showDialogIntegrado(info) {
  dialog_integrado.showModal();
  dialog_integrado_data.innerHTML = `
  <div class="content">
    <div class="avatar">
      <img
          src="/files/page/origem/produtor_${documentify(info.cpf_cnpj)}.jpg"
          alt="Avatar ${capitalize(info.nome)}"
          loading="lazy"
          onerror="this.onerror=null;this.src='/files/page/origem/produtor.png';">
    </div>
    <div class="info">
      <table border="1" cellpadding="10">
        <tr>
          <td><strong>Nome do Produtor</strong></td>
          <td>${capitalize(info.nome)}</td>
        </tr>
        <tr>
          <td><strong>Município</strong></td>
          <td>${capitalize(info.municipio)}</td>
        </tr>
        <tr>
          <td><strong>Técnico Responsável</strong></td>
          <td>${capitalize(info.tecnico_nome)}</td>
        </tr>
        <tr>
          <td><strong>Identificação do Técnico</strong></td>
          <td>${info.tecnico_identificacao}</td>
        </tr>
        <tr>
          <td><strong>Quantidade de Produtos</strong></td>
          <td>${info.qtde_abatida}</td>
        </tr>
        <tr>
          <td><strong>Data da Produção</strong></td>
          <td>${info.data_abate}</td>
        </tr>
      </table>

    </div>
  </div>
  `;

  //dialog_integrado_close
}


function capitalize(str) {
  if (!str) return str; // Verifica se a string não é nula ou vazia
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function documentify(str) {
  return str.replace(/[^a-zA-Z0-9]/g, '');
}

function toggleButtons() {
  const btnFormAction = document.getElementById('btn-form-action');
  const btnFormLoad = document.getElementById('btn-form-load');

  // Alterna a classe 'hidden' entre os dois botões
  btnFormAction.classList.toggle('hidden');
  btnFormLoad.classList.toggle('hidden');
}

